import * as React from 'react';

import { translate } from '~l10n/client';

import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation, DialogProps } from '~shared/components/Dialog';

export interface Props extends Pick<DialogProps, 'open' | 'onClose'> {
  onConfirmClick: () => void;
}

export function ActivityLaunchConfirmModal({
  open,
  onClose,
  onConfirmClick,
}: Props) {
  return (
    <DialogConfirmation
      id="confirm-launch-activity"
      open={open}
      title={translate('Start a New Question?')}
      onClose={onClose}
      closeLabel={translate('Close')}
      actions={[
        <UIButton key="primary" appearance="primary" onClick={onConfirmClick}>
          {translate('Yes')}
        </UIButton>,
        <UIButton key="cancel" onClick={onClose}>
          {translate('No')}
        </UIButton>,
      ]}
    >
      {translate('This will end responses to the current question.')}
    </DialogConfirmation>
  );
}
